import { Model } from 'modules/core/lib/mobx-rest'

export interface IInvitation {
  id: number
  user_id: number
  company_id: number
  invited: boolean
  invited_on: string | null
  confirmed: boolean
  current: boolean
  calendar_token: string | null
  permissions_group_id: number | null
  can_login: boolean
  analytics_consent: boolean | null
  affiliation: string
  first_name: string | null
  last_name: string | null
  first_day_of_week: string | null
  joined: boolean
  locale: string
  avatar: string | null
  avatar_full: string | null
  tos: boolean
  discoverability_widget_value: boolean | null
  time_format: number
  email: string | null
  login_email: string | null
  unconfirmed_email: string | null
  is_staff?: boolean
  unconfirmed_communications_email: string | null
  communications_email: string | null
  nps_due?: boolean
  nps_attempt?: number
}

class Invitation extends Model<IInvitation> {
  static urlRoot() {
    return '/invitations'
  }
}

export default Invitation
